module.exports = __webpack_public_path__ + "static/media/menu.82537211.svg";